import { GeneriekBerichtOnderwerp } from "@/entities/bericht";
import { SectionName } from "@/entities/dossier-settings";
import { UserRole } from "@/features/auth";
import { IconName } from "@/shared/components";

export const dossierViewerRoles = [
    UserRole.REGIEVOERDER,
    UserRole.SUPPORTCONSULTANT,
    UserRole.ALLEENLEZEN,
    UserRole.KLANTENSERVICE,
    UserRole.TRANSVISION,
    UserRole.DEWIT,
];

const internalDossierViewerRoles = [UserRole.REGIEVOERDER, UserRole.SUPPORTCONSULTANT, UserRole.ALLEENLEZEN, UserRole.KLANTENSERVICE];

type SectionConfig = {
    roles: UserRole[];
    title: string;
    icon: IconName;
    slug?: string;
    onderwerp?: GeneriekBerichtOnderwerp | GeneriekBerichtOnderwerp[];
};

export const sectionConfigMap: Record<SectionName, SectionConfig> = {
    DossierDetails: { roles: dossierViewerRoles, title: "Dossier details", icon: "report", onderwerp: "Algemeen" },
    BetrokkenTreinen: {
        roles: dossierViewerRoles,
        title: "Betrokken treinen en Evacuatie",
        icon: "train-conflict-2",
        slug: "betrokken-treinen",
        onderwerp: "BetrokkenTreinen",
    },
    Faciliteiten: {
        roles: internalDossierViewerRoles,
        title: "Faciliteiten",
        icon: "coffee",
        slug: "faciliteiten",
        onderwerp: "Faciliteiten",
    },
    FaciliteitenLandelijk: {
        roles: internalDossierViewerRoles,
        title: "Landelijke faciliteiten",
        icon: "coffee",
        slug: "landelijke-faciliteiten",
        onderwerp: "FaciliteitenLandelijk",
    },
    MedewerkersOpStation: {
        roles: [UserRole.REGIEVOERDER, UserRole.SUPPORTCONSULTANT],
        title: "Medewerkers op station",
        icon: "user",
        slug: "medewerkers-op-station",
    },
    Tvv: { roles: dossierViewerRoles, title: "Treinvervangend vervoer", icon: "bus", slug: "tvv", onderwerp: "TVV" },
    VsmOfOpstartplan: {
        roles: dossierViewerRoles,
        title: "VSM en Opstartplan",
        icon: "route-fork-right",
        slug: "vsm",
        onderwerp: ["VSM", "Opstartplan"],
    },
    Evaluatie: {
        roles: [UserRole.REGIEVOERDER, UserRole.SUPPORTCONSULTANT, UserRole.ALLEENLEZEN],
        title: "Evaluatie dossier",
        icon: "checklist",
        slug: "evaluatie",
    },
};
